import { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldBanner } from '@/components/PaymentMethod/fields/FieldBanner';
import { FieldCardExpiryDate } from '@/components/PaymentMethod/fields/FieldCardExpiryDate';
import { FieldCascadeSelect } from '@/components/PaymentMethod/fields/FieldCascadeSelect';
import { FieldCreditCardNumber } from '@/components/PaymentMethod/fields/FieldCreditCardNumber';
import { FieldCvvCard } from '@/components/PaymentMethod/fields/FieldCvvCard';
import { FieldEmail } from '@/components/PaymentMethod/fields/FieldEmail';
import { FieldPassword } from '@/components/PaymentMethod/fields/FieldPassword';
import { FieldPhoneNumber } from '@/components/PaymentMethod/fields/FieldPhoneNumber';
import { FieldSelect } from '@/components/PaymentMethod/fields/FieldSelect';
import { FieldText } from '@/components/PaymentMethod/fields/FieldText';
import type { MethodField } from '@/components/PaymentMethod/helpers';
import { useWithdrawStore } from '@/store';
import { FieldAmount } from './FieldAmount';
import { FieldMultiProtocolCryptoAddress } from './FieldMultiProtocolCryptoAddress';
import { FieldTextWithdraw } from './FieldTextWithdraw';

export const PaymentField: FC<Form.MethodField> = (props) => {
  const { t } = useTranslation('deposits');

  const activeThemeMode = useWithdrawStore.use.activeThemeMode();

  const args: MethodField = {
    ...props,
    activeThemeMode,
  };

  switch (args.type) {
    case Form.MethodFieldType.Amount:
      return <FieldAmount {...args} />;
    case Form.MethodFieldType.Tel:
      return <FieldPhoneNumber {...args} />;
    case Form.MethodFieldType.Select:
      return <FieldSelect {...args} />;
    case Form.MethodFieldType.Email:
      return <FieldEmail {...args} />;
    case Form.MethodFieldType.MultiProtocolCryptoAddress:
      return <FieldMultiProtocolCryptoAddress {...args} />;
    case Form.MethodFieldType.CardHolder:
      return <FieldText {...args} placeholder={t('fields.cardHolder')} />;
    case Form.MethodFieldType.Text:
      return <FieldTextWithdraw {...args} />;
    case Form.MethodFieldType.CashoutCryptoAddress:
      return <FieldText {...args} />;
    case Form.MethodFieldType.CreditCardNumber:
      return <FieldCreditCardNumber {...args} />;
    case Form.MethodFieldType.Cvv:
      return <FieldCvvCard {...args} />;
    case Form.MethodFieldType.CardExpiryDate:
      return <FieldCardExpiryDate {...args} />;
    case Form.MethodFieldType.Banner:
      return <FieldBanner {...args} />;
    case Form.MethodFieldType.CascadeSelect:
      return <FieldCascadeSelect {...args} />;
    case Form.MethodFieldType.Password:
      return <FieldPassword {...args} />;
    default:
      return null;
  }
};
